import React, { Component } from 'react';
import Heading from 'grommet/components/Heading';
import Anchor from 'grommet/components/Anchor';
import Box from 'grommet/components/Box';
import Paragraph from 'grommet/components/Paragraph';
import Power from 'grommet/components/icons/base/Power';
import WarningIcon from 'grommet/components/icons/base/Alert';
import Label from 'grommet/components/Label';
let CommonframeworkArray = ["SAPHANA", "HPECPSizer", "EPASizer", "SAP", "HPESIM"];
let EPASizingHomeMenuItems;
let ssetURL ='https://sset.ext.hpe.com/UsherAPI/';
class MyMain extends Component {

  constructor() {
    super();
    this.state = {

    }
    this.updateValue= this.updateValue.bind(this);
  }
  updateValue(){
    //console.log('insideupdatevalue',ssetURL);
    this.setState({});
  }
  render() {
    EPASizingHomeMenuItems = CommonframeworkArray.map((item) => {
      var SpaceforLoad = 'start'
      var TitleIcon;
      var text;
      var text1;
      var visibility = "show";
      var x;
      var border;
      var url = window.location.protocol+'//'+window.location.host;

      switch (item) {
        case 'SAPHANA':
          text = "HPE Sizing Tool for SAP Business Suite Powered by HANA";
          text1 = "HPE has created this unique sizer/configurator to assist in deploying SAP products on HPE Servers and is a quick and easy way to size SAP based on user requirements"
          x = url + "/SAPHANASizer/";
          border = '7px solid #ff8d6d'
          break;
        case 'SAP':
          text = "HPE Sizing Tool for SAP";
          text1 = "HPE has created this unique sizer/configurator to assist in deploying SAP products on HPE Servers and is a quick and easy way to size SAP based on user requirements."
          x = url + "/SAPSizer/"
          border = '7px solid #2ad2c9';
          break;
        case 'EPASizer':
          text = "HPE Sizing Tool for EPA";
          text1 = "The HPE Elastic Platform for Analytics (EPA) is a modular infrastructure foundation to accelerate business insights and enable organizations to rapidly deploy, efficiently scale and securely manage the explosive growth in volume, speed and variety of big data workloads."
          border = '7px solid #ff8d6d';
          x = url + "/EPASizer/"
          break;
        case 'HPECPSizer':
          text = "HPE Sizing Tool for Ezmeral Runtime Enterprise";
          text1 = "HPE Ezmeral Runtime Enterprise is a Kubernetes based software platform for deploying and managing containerized applications in the enterprise at scale, for both cloud-native and non-cloud-native monolithic applications with persistent data. It supports a variety of use cases including machine learning, analytics, IoT/Edge, DevOps (CI/CD), and application modernization."
          border = '7px solid #2ad2c9'
          x = url + "/EzmeralCPSizer/"
          break;
        case 'HPESIM':
          text = "HPESIM Sizer";
          text1 = "HPE has created this unique sizer/configurator to assist in deploying SAP products on HPE Servers and is a quick and easy way to size SAP based on user requirements."
          visibility = "hidden";
          x = url + "/HPESIM/"
          break;
        case 'CSVS':
          text = "HPE Sizing Tool for ConvergedSystem 750 (VM Workloads)";
          var text2 = "The CS750 Virtualization sizing tool is designed to assist users in identifying the HPE HW and SW needed to support a workload defined by the user. The tool will produce a general sizing BOM that can be used for budgetary quoting and as the foundation for creating live order quotes."
          border = '7px solid #2ad2c9'
          text1 = text2;
          x = url + "/SynergySizer/ "
          break;
        default:
      }
      if (item["Text"] === "Use SAPS Lookup table to view the SAP value of a specific server model.")  {
    	  return null;
      } else {
        return (
          <Box margin="small" key={item} className="Sizerbackgrond" align='center' wrap={true} pad='small' basis="1/3" style={{ visibility: visibility, borderLeft: border }} >
            <Box direction='row' className="SizerHeading">
              {TitleIcon}
              <Heading tag="h4" align="start" strong={true} style={{ color: "#01a982", marginBottom: "5px" }}>{text}</Heading>
            </Box>

            <Box direction='row' alignContent="center" align="center" style={{ width: '100%' }}>
              <Paragraph margin="none" style={{ textAlign: SpaceforLoad, width: '100%', paddingTop: "5px" }}>
                {text1}
              </Paragraph>
            </Box>
            <Anchor label='Launch Sizer' href={x} primary={true} target='_blank' className="Anchor" />
          </Box>
        );
      }
    })
    return (
      <Box margin="none" pad="none" className="HomeScreen">
        <Box margin="none" pad="none" className="AppbackGroundImage" >
        <Box size='xlarge' direction='row' margin='none' pad='small' style={{ backgroundColor: '#FFAA15' }}>
                            <WarningIcon size='small' margin='small' type='status' />
                            <Label style={{ marginLeft: '10px' }} size='medium' margin='none'>
                            To provide a consistent user experience with enhanced functionality, the HPE Greenlake cloud modules tools team will consolidate all HPE Greenlake cloud modules presales tools under the <Anchor href={ssetURL} onClick = {this.updateValue} label='Solution Sales Enablement Tool (SSET)' target='_self'/>. All workload or infrastructure-based sizing available in this portal is enabled via SSET under the “Enterprise Solutions” option.
                            </Label>
                        </Box>
          <Heading tag="h3" align="center" className="commonheading" strong={true} >HPE Enterprise Solutions and Performance (ESP) – Online Solution Sizers Portal</Heading>
          <Box margin="none" pad="none" className="AppbackGround"  >
            <Box size='xlarge' pad='medium' style={{ color: 'white' }}>Solution Sizers are sales enablement tools providing comprehensive solutions involving HPE compute, storage, networking and software products for various application workloads. Solution Sizers are currently available for workloads such as SAP, SAP HANA, Big Data and VM Workloads.
          </Box >
            <Box direction="row" wrap={true} pad="none" margin='none' justify="center" style={{ width: '100%' }} >
              {EPASizingHomeMenuItems}
            </Box>
            <Box pad='medium' style={{borderTop:'1px solid',marginTop:'4%', color:'white', backgroundColor:'rgba(66, 85, 99,0.6)'}} direction='row'>
            <Anchor animateIcon={false} primary={true} icon={<Power type='status' size='small'/>} href = "http://www.hpe.com/info/poweradvisor/" label='HPE Power Advisor' target='_blank'  />
            </Box>           
          </Box>
        </Box>
      </Box>
    );
  }
}

export default MyMain;



// WEBPACK FOOTER //
// ./src/Common.js